import React from 'react';
import { useTranslation } from 'react-i18next';
import { isPlaceholderEmail } from '../../../utils/driverLicense.js';

/**
 * Pastille rouge « Email à renseigner ».
 *
 * Un conducteur importé sans adresse porte un email bouche-trou
 * `pasdemailNNN@non-renseigne.invalid` : le schéma impose `email`, mais ce
 * n'est pas une vraie adresse et aucun mail ne peut en partir (TLD `.invalid`,
 * RFC 2606). La pastille rend cette dette visible partout où le conducteur
 * apparaît — liste et fiche.
 *
 * N'affiche rien si l'adresse est réelle : `<MissingEmailDot email={d.email} />`
 * se pose sans condition côté appelant.
 */
function MissingEmailDot({ email, className = '' }) {
  const { t } = useTranslation();
  if (!isPlaceholderEmail(email)) return null;

  const label = t('drivers.missingEmail.tooltip');
  return (
    <span
      className={`inline-block w-2.5 h-2.5 rounded-full bg-red-500 shrink-0 ${className}`}
      title={label}
      role="img"
      aria-label={label}
    />
  );
}

export default MissingEmailDot;
